var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { debounce } from 'lodash';
var NetworkSearchableDropdown = React.memo(function (_a) {
    var defaultOptions = _a.defaultOptions, _b = _a.defaultId, defaultId = _b === void 0 ? null : _b, _c = _a.placeholder, placeholder = _c === void 0 ? 'Start typing to search...' : _c, _d = _a.minSearchLength, minSearchLength = _d === void 0 ? 2 : _d, _e = _a.debounceMs, debounceMs = _e === void 0 ? 400 : _e, _f = _a.width, width = _f === void 0 ? "100%" : _f, onOptionSelected = _a.onOptionSelected, propsFetchOptions = _a.fetchOptions;
    var _g = React.useState(false), open = _g[0], setOpen = _g[1];
    var _h = React.useState(false), loading = _h[0], setLoading = _h[1];
    var _j = React.useState(defaultOptions), options = _j[0], setOptions = _j[1];
    var _k = React.useState(''), inputValue = _k[0], setInputValue = _k[1];
    var _l = React.useState(null), selectedOption = _l[0], setSelectedOption = _l[1];
    var _m = React.useState([]), searchResults = _m[0], setSearchResults = _m[1];
    // Initialize default selection
    React.useEffect(function () {
        if (defaultId && defaultOptions.length > 0) {
            var defaultOption = defaultOptions.find(function (opt) { return opt.id === defaultId; });
            if (defaultOption) {
                setSelectedOption(defaultOption);
                setInputValue(defaultOption.title);
            }
        }
    }, [defaultId, defaultOptions]);
    // Update options when defaultOptions changes
    React.useEffect(function () {
        setOptions(defaultOptions);
        if (defaultId && defaultOptions.length > 0) {
            var defaultOption = defaultOptions.find(function (opt) { return opt.id === defaultId; });
            if (defaultOption) {
                setSelectedOption(defaultOption);
                setInputValue(defaultOption.title);
            }
        }
    }, [defaultOptions]);
    var fetchOptionsData = function (searchTerm) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchFn, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    fetchFn = propsFetchOptions || defaultFetchOptions;
                    return [4 /*yield*/, fetchFn(searchTerm)];
                case 2:
                    data = _a.sent();
                    setSearchResults(data);
                    setOptions(data);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error fetching options:', error_1);
                    setSearchResults([]);
                    setOptions([]);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Default fetch function if none provided
    var defaultFetchOptions = function (searchTerm) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, [
                            { id: 1, title: "".concat(searchTerm, " Result 1"), image: 'https://example.com/1.jpg' },
                            { id: 2, title: "".concat(searchTerm, " Result 2"), image: 'https://example.com/2.jpg' },
                            { id: 3, title: "".concat(searchTerm, " Result 3"), image: 'https://example.com/3.jpg' },
                        ]];
            }
        });
    }); };
    var debouncedFetch = React.useMemo(function () { return debounce(fetchOptionsData, debounceMs); }, [debounceMs]);
    React.useEffect(function () {
        return function () {
            debouncedFetch.cancel();
        };
    }, [debouncedFetch]);
    var handleInputChange = function (_event, newInputValue) {
        setInputValue(newInputValue);
        if (newInputValue.length >= minSearchLength) {
            debouncedFetch(newInputValue);
        }
        else {
            setSearchResults([]);
            setOptions(defaultOptions);
        }
    };
    var handleOptionSelect = function (option) {
        setSelectedOption(option);
        if (option) {
            setInputValue(option.title);
            onOptionSelected === null || onOptionSelected === void 0 ? void 0 : onOptionSelected(option.id);
        }
        else {
            onOptionSelected === null || onOptionSelected === void 0 ? void 0 : onOptionSelected(null);
        }
        setOpen(false);
    };
    return (_jsx(Autocomplete, { id: "network-searchable-dropdown", sx: { width: width }, open: open, onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.title; }, options: options, loading: loading, value: selectedOption, onChange: function (_event, newValue) { return handleOptionSelect(newValue); }, inputValue: inputValue, onInputChange: handleInputChange, filterOptions: function (x) { return x; }, clearOnBlur: false, selectOnFocus: true, handleHomeEndKeys: true, freeSolo: false, renderOption: function (props, option) {
            var _a;
            return (_jsx("li", __assign({}, props, { children: _jsxs(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        py: 1,
                        px: 2
                    }, children: [_jsx(Avatar, { src: option.image, alt: option.title, sx: {
                                width: 32,
                                height: 32,
                                mr: 2,
                                backgroundColor: 'grey.300'
                            }, children: (_a = option === null || option === void 0 ? void 0 : option.title) === null || _a === void 0 ? void 0 : _a.charAt(0) }), _jsx(Typography, { variant: "body1", noWrap: true, children: option.title })] }) })));
        }, renderInput: function (params) {
            var _a;
            return (_jsx(TextField, __assign({}, params, { placeholder: placeholder, InputProps: __assign(__assign({}, params.InputProps), { startAdornment: selectedOption && (_jsx(Avatar, { src: selectedOption.image, alt: selectedOption.title, sx: {
                            width: 24,
                            height: 24,
                            ml: 1,
                            mr: 1,
                            backgroundColor: 'grey.300',
                            fontSize: '0.875rem'
                        }, children: (_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title) === null || _a === void 0 ? void 0 : _a.charAt(0) })), endAdornment: (_jsxs(React.Fragment, { children: [loading ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })) }), sx: {
                    '& .MuiInputBase-root': {
                        paddingLeft: selectedOption ? 0.5 : 2,
                    },
                } })));
        } }));
});
export default NetworkSearchableDropdown;
